import { render, staticRenderFns } from "./documentx.vue?vue&type=template&id=2ce11792&"
import script from "./documentx.vue?vue&type=script&lang=js&"
export * from "./documentx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports